import React, { useEffect, useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Typography, 
  Link, 
} from "@mui/material";

import Header from "./Header";
import Footer from "./Footer";
import FooterPlayer from "./FooterPlayer"; // ✅ new import

export default function LandingPage() {

            const [data, setData] = useState(null);
  const [cartQty, setCartQty] = useState(0);
   const [user, setUser] = useState(null);
   const [mobileOpen, setMobileOpen] = useState(false);
   const [anchorEl, setAnchorEl] = useState(null);
 
     useEffect(() => {
       try {
         const savedCart = localStorage.getItem('cart');
         if (savedCart) {
           const cart = JSON.parse(savedCart);
           if (Array.isArray(cart)) {
             setCartQty(cart.length);
           } else {
             setCartQty(0);
           }
         } else {
           setCartQty(0);
         }
       } catch (e) {
         console.error('Failed to parse cart', e);
         setCartQty(0);
       }
     }, []);
   
   
 
   const navLinks = [
     { text: "TOUR", link: "/#upcoming" },
     { text: "STREAM", link: "/#stream" },
     { text: "RELEASES", link: "/#releases" },
     { text: "SHOP", link: "/#boutique", external: true },
     { text: "ABOUT", link: "/#about" },
   ];
 
   const socialLinks = [
    { text: 'Facebook', link: 'https://www.facebook.com/example' },
    { text: 'Twitter', link: 'https://twitter.com/example' },
    { text: 'Instagram', link: 'https://www.instagram.com/example' },
    { text: 'LinkedIn', link: 'https://www.linkedin.com/company/example' },    
];

  return (
    <>

<Header
  menuItems={navLinks}
  logo="/images/mihu-logo-trans.png" 
  cartQty={cartQty}
/>

      {/* Content wrapper with padding to avoid overlap with player */}
      <Box sx={{ pb: { xs: 10, md: 8 } }}>

    <Box
      sx={{
        backgroundImage: "url('/images/rainbow_bg.jpg')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundAttachment: "fixed",
        backgroundPosition: "center bottom",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container
        sx={{
          backgroundColor: "lightgray",
          border: "1px solid #000",
          borderRadius: "8px",
          p: 4,
          textAlign: "center",
          maxWidth: "700px",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Either you already have an account or a request for this email is
          already pending!
        </Typography>
        <Typography variant="body1" paragraph>
          If you forgot your password, you can{" "}
          <Link
            href="/recoverPassword"
            target="_blank"
            underline="hover"
            sx={{ color: "dodgerblue", fontWeight: "bold" }}
          >
            recover your account here
          </Link>
          .
        </Typography>
        <Typography variant="body1" paragraph>
          Otherwise, you will receive an email once your request has been
          approved. Use the access link and login credentials in that email to
          sign in to your Hub account.
        </Typography>
        <Typography variant="h6" mt={3}>
          <strong>Questions?</strong>{" "}
          <Link
            href="mailto:musicishealingus@gmail.com"
            target="_blank"
            underline="hover"
            sx={{ color: "dodgerblue", fontWeight: "bold" }}
          >
            Email the MIHU Hub Team
          </Link>
        </Typography>
      </Container>
    </Box>

  
        <Footer socialLinks={socialLinks} />
      </Box>

      {/* ✅ Fixed FooterPlayer at bottom */}
      <FooterPlayer />
    </>
  );
}
